import { API, TagsAPI } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getComputeAppName } from '_deziiign/main/pages/MainTagAdminPage/section/Platforms';
import { ADMIN_TAGS_TYPE } from '_deziiign/main/pages/MainTagAdminPage/types';
import { IPlatform } from 'shared/reducers/tagAdminSlice';

const getEntityTypes = (nArr: IPlatform) => {
  return [
    ...nArr?.entityTypes || [], 
    ...nArr?.entityTypesEduTags || [], 
    ...nArr?.entityTypesRequiredTags || []
  ]
}

export const fetchPlatformCategoryOpt = createAsyncThunk(
  'tagAdmin/fetchPlatformCategoryOpt',
  async () => {
    const json = await API.Json(
        TagsAPI.GetEntityTypesByContexts())
  
    return json;
  }
);

export const fetchAllCategory = createAsyncThunk(
  'tagAdmin/fetchAllCategory',
  async () => {
    const json = await API.Json(
      TagsAPI.GetTagsTree({ 
        status: [0],
        isHeaderIgnored: true, 
        onlyCategories: true, 
      })
  )
  
    return json;
  }
);

export const fetchCurrentPlatformData = createAsyncThunk(
  'tagAdmin/fetchCurrentPlatformData',
  async (args: any, { getState }: { getState: any }) => {
    const { platformName, tag } = args;
    const { platforms, currentPlatform: { editCategory } } = getState().tagAdmin;

    const platform = platforms?.find((i: any) => getComputeAppName(i) === platformName);

    const entity = getEntityTypes(platform)

    const editData = { editCategory: { ...editCategory, mainTag: tag }}

    const json = await API.Json(
        TagsAPI.GetTagsTree({ 
          entityTypes: entity, 
          status: [0], 
          onlyCategories: true,
          includeSubCategories: true,
        })
    )

    return {
      platform,
      ...editData,
      categories: json
    };
  }
);

export const fetchCategoryEdit = createAsyncThunk(
  'tagAdmin/fetchCategoryEdit',
  async (args: any, { getState }: { getState: any }) => {
    const { id, isChild, onlyCategoryUpdate, tag } = args;
    const { currentPlatform, type } = getState().tagAdmin;

    const method = TagsAPI.GetTag;

    //@ts-ignore
    const mainTag = tag ? tag : await API.Json(method({ idTag: id }))
    const tagType = type === ADMIN_TAGS_TYPE.education
    //@ts-ignore
    const childrens =  await API.Json(TagsAPI.GetTagsByFilter({ 
      groupIds: [ mainTag?.tagId ], 
      appName: currentPlatform.platform.appName, 
      appContext: currentPlatform.platform.context,
      isEducation: tagType
    }))

    const editCategory = onlyCategoryUpdate ? { 
      editCategory: { 
        ...currentPlatform?.editCategory, 
        mainTag
      }
    } : { 
        editCategory: { 
          mainTag, 
          childrens 
        }
      }

    return {
      ...currentPlatform,
      ...editCategory
    };
  }
);


export const updateEditedCategory = createAsyncThunk(
  'tagAdmin/updateEditedCategory',
  async (args: any, { getState }: { getState: any }) => {
    const { tag } = args;
    const { currentPlatform } = getState().tagAdmin;

    // @ts-ignore
    const mainTag = tag
    // //@ts-ignore
    const childrens =  await API.Json(TagsAPI.GetTagsByFilter({ groupIds: [ mainTag?.tagId ]}))

    return { ...currentPlatform, editCategory: { mainTag, childrens } }
  }
);


import { API, TagsAPI } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getComputeAppName } from '_deziiign/main/pages/MainTagAdminPage/section/Platforms';
import { ADMIN_TAGS_TYPE } from '_deziiign/main/pages/MainTagAdminPage/types';
import { IPlatform } from 'shared/reducers/tagAdminSlice';

const getEntityTypes = (nArr: IPlatform) => {
  return [
    ...nArr?.entityTypes || [], 
    ...nArr?.entityTypesEduTags || [], 
    ...nArr?.entityTypesRequiredTags || []
  ]
}

export const fetchPlatformCategoryOpt = createAsyncThunk(
  'tagAdmin/fetchPlatformCategoryOpt',
  async () => {
    const json = await API.Json(
        TagsAPI.GetEntityTypesByContexts())
  
    return json;
  }
);

export const fetchAllCategory = createAsyncThunk(
  'tagAdmin/fetchAllCategory',
  async () => {
    const json = await API.Json(
      TagsAPI.GetTagsTree({ 
        status: [0],
        isHeaderIgnored: true, 
        onlyCategories: true, 
      })
  )
  
    return json;
  }
);

export const fetchCurrentPlatformData = createAsyncThunk(
  'tagAdmin/fetchCurrentPlatformData',
  async (args: any, { getState }: { getState: any }) => {
    const { platformName, tag } = args;
    const { platforms, currentPlatform: { editCategory } } = getState().tagAdmin;

    const platform = platforms?.find((i: any) => getComputeAppName(i) === platformName);

    const entity = getEntityTypes(platform)

    const editData = { editCategory: { ...editCategory, mainTag: tag }}

    const json = await API.Json(
        TagsAPI.GetTagsTree({ 
          entityTypes: entity, 
          status: [0], 
          onlyCategories: true,
          includeSubCategories: true,
        })
    )

    return {
      platform,
      ...editData,
      categories: json
    };
  }
);

export const fetchCategoryEdit = createAsyncThunk(
  'tagAdmin/fetchCategoryEdit',
  async (args: any, { getState }: { getState: any }) => {
    const { id, isChild, onlyCategoryUpdate, tag } = args;
    const { currentPlatform, type } = getState().tagAdmin;

    const method = TagsAPI.GetTag;

    //@ts-ignore
    const mainTag = tag ? tag : await API.Json(method({ idTag: id }))
    const tagType = type === ADMIN_TAGS_TYPE.education
    //@ts-ignore
    const childrens =  await API.Json(TagsAPI.GetTagsByFilter({ 
      groupIds: [ mainTag?.tagId ], 
      appName: currentPlatform.platform.appName, 
      appContext: currentPlatform.platform.context,
      isEducation: tagType
    }))

    const editCategory = onlyCategoryUpdate ? { 
      editCategory: { 
        ...currentPlatform?.editCategory, 
        mainTag
      }
    } : { 
        editCategory: { 
          mainTag, 
          childrens 
        }
      }

    return {
      ...currentPlatform,
      ...editCategory
    };
  }
);


export const updateEditedCategory = createAsyncThunk(
  'tagAdmin/updateEditedCategory',
  async (args: any, { getState }: { getState: any }) => {
    const { tag } = args;
    const { currentPlatform } = getState().tagAdmin;

    // @ts-ignore
    const mainTag = tag
    // //@ts-ignore
    const childrens =  await API.Json(TagsAPI.GetTagsByFilter({ groupIds: [ mainTag?.tagId ]}))

    return { ...currentPlatform, editCategory: { mainTag, childrens } }
  }
);


